import React from 'react';
import { Link } from 'gatsby';

import Container from 'components/ui/Container';
import Button from 'components/ui/Button';
import TitleSection from 'components/ui/TitleSection';

import * as Styled from './styles';

interface Props {
  title: string;
  subtitle?: string;
  content: React.ReactNode;
  linkTo: string;
  linkText: string;
  linkMore: string;
  linkMoreText: string;
}

const Banner: React.FC<Props> = ({ title, subtitle, content, linkTo, linkText, linkMore, linkMoreText }) => (
  <Styled.Banner>
    <Container section>
      <TitleSection title={title} subtitle={subtitle} />
      <Styled.Content>
        {typeof content === 'string'
          ? content
              .split(/\n\n+/)
              .filter(Boolean)
              .map((paragraph, i) => <p key={i}>{paragraph.trim()}</p>)
          : content}
      </Styled.Content>
      <Link to={linkTo}>
        <Button primary>{linkText}</Button>
      </Link>
      <Link to={linkMore}>
        <Button>{linkMoreText}</Button>
      </Link>
    </Container>
  </Styled.Banner>
);

export default Banner;
